import Toolbar, { Separator } from 'common/components/Toolbar'
import { IQRANavUtilsConsumerComponentInitProps } from 'common/utils/navigation/qraNavUtils'

import LocalFilterButton from 'features/RiskManagement/Components/LocalFilter/LocalFilterButton'
import DisplayThresholdButtonAndModal from 'features/RiskManagement/Components/LocalFilter/RiskUnitAndThreshold'
import GraphsAndTableTab from 'features/RiskManagement/Components/Toolbar/GraphsAndTableTab'
import WISDropdownTab from 'features/RiskManagement/Components/Toolbar/WISDropdownTab'

import SaveStateAndRunScenarioButton from './SaveStateAndRunScenarioButton'

/**
 * Graph / Table tab navigation and filter components
 * Tab navigation requires supporting routes to be defined in router.
 *
 * @param qraViewBasePath - URL path the tab selection generated url to be based on
 * @returns component
 */
const CurrentStateToolbar = ({
  qraBasePath,
  qraViewBasePath
}: IQRANavUtilsConsumerComponentInitProps) => {
  // TODO: restructure routing to v6 format then remove this hack
  const strippedQraViewBasePath = qraViewBasePath.replace(
    /\/(graphs|data-table)$/,
    ''
  )

  return (
    <Toolbar>
      <GraphsAndTableTab
        qraBasePath={qraBasePath}
        qraViewBasePath={strippedQraViewBasePath}
      />
      <Separator />
      <LocalFilterButton />
      <Separator />
      <WISDropdownTab finalComponent={<SaveStateAndRunScenarioButton />} />
      <div className='flex-1' />
      <DisplayThresholdButtonAndModal />
    </Toolbar>
  )
}

export default CurrentStateToolbar
